import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import TreeView, { flattenTree } from "react-accessible-treeview";

export default class Accounts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'account',
            data: null,
            tree: null,
            loading: true,
            id_to_remove: null
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    refreshData() {
        this.setState({ loading: true });

        this.httpPost("api/v1/" + this.state.controllerName + "/list/", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {

                    var nodes = {
                        name: "",
                        children: [],
                    };

                    data.records.forEach(l1 => {
                        if (l1.type == 1) {
                            var children = [];
                            data.records.forEach(l2 => {
                                if (l2.type == 2 && l2.parentCode == l1.fullCode) {

                                    var children2 = [];
                                    data.records.forEach(l3 => {
                                        if (l3.type == 3 && l3.parentCode == l2.fullCode) {
                                            children2.push({
                                                name: l3.fullCode + " - " + l3.title,
                                                id: l3.id
                                            })
                                        }
                                    });

                                    children.push({
                                        name: l2.fullCode + " - " + l2.title ,
                                        id: l2.id,
                                        children: children2
                                    })
                                }
                            });

                            nodes.children.push(
                                {
                                    name: l1.fullCode + " - " + l1.title,
                                    id: l1.id,
                                    children: children,
                                });
                        }
                    })

                    var tree = flattenTree(nodes);

                    this.setState({
                        tree: tree,
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    import(type) {
        this.httpPost("api/v1/account/import", {
            type,
            companyId: this.state.data.global.company.id,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت وارد شد");
                this.refreshData();
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <div>
                    <div className="nk-content-body">
                        <div className="nk-block-head nk-block-head-sm">
                            <div className="nk-block-between">
                                <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">کدینگ حسابها</h3>
                                    <div className="nk-block-des text-soft">
                                        <p>شما {this.money(this.state.data.recordsCount) } حساب ثبت شده دارید</p>
                                    </div>
                                </div>
                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            <ul className="nk-block-tools g-3">
                                                <li className="nk-block-tools-opt">
                                                    <div className="drodown">
                                                        <a href="#" className="dropdown-toggle btn btn-icon btn-primary" data-bs-toggle="dropdown" aria-expanded="true"><em className="icon ni ni-plus"></em></a>
                                                        <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                            <ul className="link-list-opt no-bdr">
                                                                <li><NavLink to="/account/new1/"><span>افزودن حساب گروه</span></NavLink></li>
                                                                <li><NavLink to="/account/new2/"><span>افزودن حساب کل</span></NavLink></li>
                                                        <li><NavLink to="/account/new3/"><span>افزودن حساب معین</span></NavLink></li>
                                                        <li><a className="hand" onClick={e => this.import(1)}><span>ورود کدینگ پیش فرض بازرگانی</span></a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nk-block">
                            <div className="card card-bordered card-stretch">
                                {this.state.data.recordsCount <= 0 ?
                                    <div className="card-inner-group">
                                        <div className="example-alert">
                                            <div className="alert alert-pro alert-warning">
                                                <div className="alert-text">
                                                    <h6>توجه</h6>
                                                    <p>در حال حاضر هیچ حسابی برای شرکت شما ثبت نشده است</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className="card-inner-group">
                                            <div className="card-inner p-0">
                                                <div className="directory">
                                                <TreeView
                                                    data={this.state.tree}
                                                    className="basic"
                                                    aria-label="basic example tree"
                                                        nodeRenderer={({
                                                            element,
                                                            isBranch,
                                                            isExpanded,
                                                            getNodeProps,
                                                            level
                                                        }) => (
                                                            <div {...getNodeProps()} style={{ paddingRight: 20 * (level - 1) }}>
                                                                {!isExpanded && level != 3 && <i className="fa fa-plus"></i>}
                                                                {isExpanded && level != 3 && <i className="fa fa-minus"></i>}
                                                                {element.name}
                                                                <div className="toolbar">
                                                                    <NavLink to={"/account/edit/" + element.id + "/"}><em className="icon ni ni-eye"></em><span>ویرایش</span></NavLink>
                                                                    <a className="hand" onClick={e => this.confirmRemove(element.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف</span></a>
                                                                </div>
                                                        </div>
                                                    )}
                                                    />
                                                </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>


                </div>
        
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        this.getGlobalContainer(),
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.isEmptyCompanies(this.state.data.global) ? this.renderNoCompanyRegister() : this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}